module.exports = {
  initializeUploadCheckOnce: function () {
    return window.Android;
  },

  initializeUpload: function () {
    var view = this.loadListContent(this.uploadViewKey);
    var globalAppUploadEvent = 'ik.editor.photoupload';
    var $addButton = this.$el.find('dt a[data-key="add"]');
    var debouncedOpenProjectTab = _.debounce(_.bind(openProjectTab, this), 600);
    var $button = this.$el.find('dt a[data-key="' + this.uploadViewKey + '"]');

    this.appBridge.on(globalAppUploadEvent, function (event, data) {
      var id = data.photoId;

      debouncedOpenProjectTab();
      view.views[id] = view.getNewThumbnail();
      view.views[id].toggleProgressBar(true);
      view.views[id].updateProgressBar(1);
      view.complete(id, data);
    });

    $addButton.on('click', _.bind(function (event) {
      var sizeName = 'o';

      this.appBridge.callAndroid('photo_upload', {
        size_name: sizeName
      });
    }, this));

    function openProjectTab () {
      this.showListContent($button);
      $button.parent().addClass('active');
    }
  }
};
